// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"f054ffd8","146":"02f77d28","306":"71147d3c","371":"a75fccdf","453":"0e1917ba","511":"69c72fc4","549":"98d6457a","587":"7a9f6cd2","606":"35ec0a9e","979":"f406ad77"}[chunkId] + ".chunk.js";
};